import { render, staticRenderFns } from "./tiendas.vue?vue&type=template&id=ec9fe48e&scoped=true&"
import script from "./tiendas.vue?vue&type=script&lang=js&"
export * from "./tiendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9fe48e",
  null
  
)

export default component.exports